import React from 'react';
import { TripCard } from '../../../redux/trip/trip.types';
import { isNotesEmpty } from '../../../utils/slate.utils';
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';

interface CardDeleteConfirmationDialogProps {
  card: TripCard;
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  scheduledDays?: string[];
}

function CardDeleteConfirmationDialog({
  card,
  open,
  onCancel,
  onConfirm,
  scheduledDays,
}: CardDeleteConfirmationDialogProps) {
  const cardName = card.customName ?? card.name;
  const hasNotes = !isNotesEmpty(card);
  const hasScheduledDays = Boolean(scheduledDays?.length);

  return (
    <ConfirmDialog
      open={open}
      title='Delete place?'
      confirmLabel='Delete'
      onCancel={onCancel}
      onConfirm={onConfirm}
      destructive
    >
      {hasNotes && (
        <>
          Deleting <strong>{cardName}</strong> will permanently remove its saved notes. This cannot
          be undone.
        </>
      )}
      {hasScheduledDays && (
        <span style={{ display: 'block', marginTop: hasNotes ? 12 : 0 }}>
          This card is also scheduled on your itinerary:
          <ul style={{ margin: '6px 0 0', paddingLeft: 20 }}>
            {scheduledDays!.map((day) => (
              <li key={day}>{day}</li>
            ))}
          </ul>
          <span style={{ display: 'block', marginTop: 20 }}>
            Deleting it will remove these events.
          </span>
        </span>
      )}
    </ConfirmDialog>
  );
}

CardDeleteConfirmationDialog.displayName = 'CardDeleteConfirmationDialog';
export default CardDeleteConfirmationDialog;
